import React from 'react';
import { Box } from '@mui/material';
import ContactPage from '../../pages/ContactPage';

const ContactMobile = () => (
  <Box
    sx={{
      '& .section': {
        height: 'auto !important',
        minHeight: 'auto !important'
      }
    }}
  >
    <ContactPage />
  </Box>
);

export default ContactMobile;
